import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as jwtDecode from 'jwt-decode';

import { IoIosArrowDown } from 'react-icons/io';
import { Text, WrapperFlex, InputDropdown } from '@unimed-fesp/components';
import { SelectContratanteContainer } from './styles';

import { isContratanteNestle } from '../../../utils/userRole';

import theme from '../../../styles/theme';
import { TipoPerfilUsuarioEnum } from '../../../enums';

const textNestle = 'Nestlé';

const DropChangeParametrizacao = ({
  contratantes,
  onClick,
  headerText,
  nomeComplemento,
}) => {
  const { usuario, accessToken } = useSelector((state) => state.auth);

  const { IsAdm } = jwtDecode(accessToken);

  // #region Flags
  const HAS_NESTLE = nomeComplemento?.toLocaleUpperCase() === 'NESTLE';
  const IS_ADM = IsAdm && IsAdm.toLocaleUpperCase() === 'TRUE';
  const IS_NESTLE_OR_PARAMETRIZACAO_UNITARIA =
    (!IS_ADM && isContratanteNestle(usuario)) || contratantes?.length < 1;
  // #endregion

  const getOptionsDrop = useCallback(() => {
    if (!IS_ADM) return contratantes.map((contratante) => contratante.nome);
    if (HAS_NESTLE)
      return [TipoPerfilUsuarioEnum.returnNameFormattedForName.Adm, textNestle];

    return [
      TipoPerfilUsuarioEnum.returnNameFormattedForName.Adm,
      ...contratantes.map((contratante) => contratante.nome),
    ];
  }, [HAS_NESTLE, IS_ADM, contratantes]);

  const selectedParametrizacao = useCallback(
    (optionDrop) => {
      const targetParametrizacao =
        optionDrop === textNestle ? contratantes[0]?.nome : optionDrop;

      onClick(targetParametrizacao);
    },
    [contratantes, onClick]
  );

  if (IS_NESTLE_OR_PARAMETRIZACAO_UNITARIA)
    return (
      <SelectContratanteContainer data-testid="select-contratantes">
        <WrapperFlex justifyStart alignCenter>
          <Text
            bold
            color={theme.bgWhite}
            text={
              usuario.role === TipoPerfilUsuarioEnum.returnNameForName.Adm
                ? 'Administrador'
                : 'Contratante:'
            }
          />
          {usuario.role !== TipoPerfilUsuarioEnum.returnNameForName.Adm && (
            <Text
              color={theme.bgWhite}
              text={isContratanteNestle(usuario) ? textNestle : headerText}
              padding="6"
              marginLeft={5}
            />
          )}
        </WrapperFlex>
      </SelectContratanteContainer>
    );

  return (
    <InputDropdown
      options={getOptionsDrop()}
      handleClickOption={selectedParametrizacao}
      width={490}
      placeHolder="Pesquise por código ou nome da contratante"
      position="right-bottom"
    >
      <SelectContratanteContainer data-testid="select-contratantes">
        <WrapperFlex justifyStart alignCenter>
          <Text
            bold
            color={theme.bgWhite}
            text={
              usuario.role === TipoPerfilUsuarioEnum.returnNameForName.Adm
                ? 'Administrador'
                : 'Contratante:'
            }
            cursor="poiter"
          />
          <WrapperFlex marginLeft={5} gap={5}>
            {headerText && (
              <Text
                color={theme.bgWhite}
                text={isContratanteNestle(usuario) ? textNestle : headerText}
              />
            )}
            <IoIosArrowDown color={theme.bgWhite} />
          </WrapperFlex>
        </WrapperFlex>
      </SelectContratanteContainer>
    </InputDropdown>
  );
};

export default DropChangeParametrizacao;
